import { createFileRoute } from '@tanstack/react-router'

import { RouteModal } from '@/components/route-modal'

import { PromotionForm } from './-promotion-form'

export const Route = createFileRoute('/_authenticated/_general/promotions/create')({
	component: RouteComponent,
	staticData: { crumb: ({ context: { L } }) => L.Promotions.CreateTitle() }
})

function RouteComponent() {
	return (
		<RouteModal asDrawer>
			<PromotionForm />
		</RouteModal>
	)
}
